module.exports = __webpack_public_path__ + "img/house.ac729007.png";